module.exports = __webpack_public_path__ + "static/img/znsj_p2.9456077.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/znsj_p2.png
// module id = wOaa
// module chunks = 19